import React from 'react';
import { Row, Col } from '../../util_grid/grid.js';
import Layout_base from './layout-base.jsx';

/**
 * Used for two different CMS components side by side
 * e.g. Banner + ankeilerGrid
 */
class Layout_two_diff_flex  extends Layout_base {
  render() {
    return (
      <Col xs={12} className="generic__two-diff-flex">
        {this.sectionHead()}
        <Row>
          <Col xs={12} md={6}>{this.componentDOM(0)}</Col>
          <Col xs={12} md={6}>{this.componentDOM(1)}</Col>
        </Row>
        {this.sectionFooter()}
      </Col>
    );
  }
}

export default Layout_two_diff_flex;
